import { generatePath } from 'react-router';

import { addParamsToUrl } from 'utils/query';
import { GameAnalyticsRequest } from 'store/api/game-analytics/types';
import { UserAuditEventListRequest } from 'store/api/user-audit-events';

import { URL } from '../constants';
import { apiLoaderInstance } from '../instance';

export const downloadAuditEvents = (
  params?: Omit<UserAuditEventListRequest, 'limit' | 'offset'>
) =>
  apiLoaderInstance.get(
    addParamsToUrl(URL.AUDIT_EVENTS_EXPORT, params, {
      preserveNull: true,
    }),
    {
      responseType: 'blob',
    }
  );

export const downloadGameAnalyticsSessionsReport = ({
  tenantId,
  ...params
}: Omit<GameAnalyticsRequest, 'limit' | 'offset'>) =>
  apiLoaderInstance.get(
    addParamsToUrl(
      generatePath(URL.TENANT_GAME_ANALYTICS_SESSIONS_REPORT_EXPORT, {
        id: tenantId,
      }),
      params
    ),
    {
      responseType: 'blob',
    }
  );
